module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-from-right-096e5bb780ea8b60b2711371c3b6bd42.svg";